import { Box, Image, Text } from "@chakra-ui/react";
import "./styles.css";
import React from "react";
import { color } from "../../utils/theme";
import { ProjectType } from "../../utils/types/cycle";
import { FaArrowRight } from "react-icons/fa";

interface NavCardProps {
  showInfo?: boolean;
  showIcon?: boolean;
  width?: string | number;
  height?: string | number;
  icon: string;
  title: string;
  project?: ProjectType;
  onClick: () => void;
  onInfoClick?: () => void;
}

const NavCard: React.FC<NavCardProps> = ({
  showInfo,
  showIcon = true,
  icon,
  title,
  project,
  width,
  height,
  onClick,
  onInfoClick,
}) => {
  return (
    <Box
      className="nav-card"
      position={"relative"}
      w={width ? width : [300, 300, 300, 300, 300, 350]}
      sx={{
        h: height ? height : 200,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        gap: 5,
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        borderRadius: "md",
        fontFamily: "body",
        borderColor: "gray.300",
        borderWidth: 1,
        color: color.text,
        transition: "all 0.5s ease",
      }}
      boxShadow={"sm"}
      _hover={{
        shadow: "xl",
        borderWidth: 1,
        color: color.primary,
        borderColor: color.primary,
        backgroundColor: "white.800",
      }}
      onClick={onClick}
    >
      <>
        {showIcon === true && (
          <Box
            h={"40%"}
            pt={10}
            alignContent={"center"}
            justifyContent={"center"}
            flex={"column"}
          >
            <Image
              src={require(`../../assets/${icon}.png`)}
              style={{ width: "60px", height: "60px" }}
              ml={3}
            />
          </Box>
        )}
      </>

      <Box
        h={"100%"}
        justifyContent={"center"}
        flex={"column"}
        alignContent={"center"}
        alignItems={"center"}
        w={"100%"}
        px={10}
        position={"relative"}
      >
        <Text fontSize={16} textAlign={"center"}>
          {title}
        </Text>

        {showInfo && (
          <Text
            fontSize={16}
            bottom={5}
            onClick={(event) => {
              event.stopPropagation();
              onInfoClick && onInfoClick();
            }}
            fontWeight={"normal"}
            alignSelf={"center"}
            right={20}
            left={20}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            display={"flex"}
            flexDirection={"row"}
            color={color.primary}
            position={"absolute"}
          >
            More Info <FaArrowRight fontSize={15} style={{ marginLeft: 5 }} />
          </Text>
        )}
        {project && (
          <>
            <Text fontSize={12} textAlign={"center"}>
              Total Cycles:- {project.cycles?.length}
            </Text>
            <Text fontSize={12} textAlign={"center"}>
              Change Ideas:- {project.change_ideas?.length}
            </Text>
            <Text fontSize={12} textAlign={"center"}>
              Status:- {project.status}
            </Text>
          </>
        )}
      </Box>
    </Box>
  );
};

export default NavCard;
